"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const WorkItem_1 = __importDefault(require("@Components/WorkItem"));
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const CSWorkItemTable = (props) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { rightsholderStore, claimingToolSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { workModels, selectWork } = props;
    const currentClaimedShares = rightsholderStore.rightsholderClaimedShares
        ? rightsholderStore.rightsholderClaimedShares.workClaimedShares
        : [];
    return (react_1.default.createElement(react_1.default.Fragment, null, workModels.map((work) => (react_1.default.createElement(WorkItem_1.default, { data: work, rightsHolderId: rightsholderStore.currentRightsholderId, key: work.id ? work.id : '', claimType: true, selectWorkForClaiming: selectWork, navigate: navigate, claimedShare: currentClaimedShares.filter((share) => share.id === work.id)[0], onCatalogClick: () => claimingToolSearchStore.setRedirectingToCatalog(true) })))));
};
exports.default = (0, mobx_react_1.observer)(CSWorkItemTable);
